"use strict";
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function get() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
exports._ = _export_star;
